/** Campos POD en cabecera de pedido (listado o detalle). */
export interface OrderPodFlags {
  requiresPodForDelivery?: boolean;
  requiresAcceptedPod?: boolean;
  hasPod?: boolean;
  isPodCompliant?: boolean;
  podMissing?: boolean;
  podEnforcementActive?: boolean;
  deliverBlockedByPodPolicy?: boolean;
}

/** Texto breve para operación (portal cliente). */
export function orderPodComplianceLabel(o: OrderPodFlags): string {
  const req = o.requiresPodForDelivery === true;
  const acc = o.requiresAcceptedPod === true;
  const enf = o.podEnforcementActive === true;
  const blocked = o.deliverBlockedByPodPolicy === true;
  const has = o.hasPod === true;
  const ok = o.isPodCompliant === true;

  if (!req && !enf) return "Sin exigencia POD en política.";
  const bits: string[] = [];
  if (req) bits.push("POD requerido");
  if (acc) bits.push("aceptación requerida");
  if (enf) bits.push("enforcement activo");
  if (blocked) bits.push("entrega bloqueada por política");
  if (has) bits.push(ok ? "POD conforme" : "POD no conforme");
  else if (o.podMissing) bits.push("falta POD");
  return bits.join(" · ") || "—";
}
